import { createTheme } from '@mui/material/styles';

// Create MUI theme following CLAUDE.md patterns
export const theme = createTheme({
  typography: {
    fontFamily: "Inter, sans-serif",
    h1: {
      fontSize: 60,
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: 45,
      fontWeight: 600,
      lineHeight: "normal",
    },
    h3: {
      fontSize: 32,
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: 24,
      fontWeight: 600,
    },
    h5: {
      fontSize: 22,
      fontWeight: 600,
      lineHeight: "27px",
      letterSpacing: "0.22px",
    },
    h6: {
      fontSize: 18,
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: 18,
      fontWeight: 400,
    },
    body2: {
      fontSize: 16,
      fontWeight: 400,
    },
    caption: {
      fontSize: 14,
      fontWeight: 400,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});